
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightRoof as ObiLightRoofElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-roof.js';
 
 
 

 
 export const ObiLightRoof = createComponent({
   react: React,
   tagName: 'obi-light-roof',
   elementClass: ObiLightRoofElement,
   events: {
     
   }
  });
 
 